<template>
  <div>
    <task-detail @onSave="taskCreated" />
    <!-- <policy-detail @onClosed="fetchDetail" /> -->

    <content-loading v-if="isLoading" />
    <div v-else>
      <b-card no-body class="custom-card shadow-none custom-accordion">
        <!-- <b-card-header header-tag="header" role="tab">
          <a v-b-toggle="'accordion_analysis'" class="text-dark" href="javascript: void(0);">
            <h5>
              {{ $t("risk.analysis") }}
            </h5>
          </a>
        </b-card-header> -->

        <div class="d-flex flex-wrap mt-4 pl-4 pr-4 mb-4">
          <h1 class="title mb-4">{{ $t("risk.new") }}</h1>
          <div class="d-flex flex-wrap flex-grow-0 flex-shrink-0" style="width: 100%; gap: 1rem;">
            <div class="r-select-container w-100">
              <b-form-group>
                <template #label>
                  <h6>{{ $t("risk.name") }} <span class="text-danger">*</span></h6>
                </template>
                <sweet-input :disableValidation="true" v-model="form.name" />
              </b-form-group>
            </div>
            <div class="r-select-container w-100">
              <b-form-group>
                <template #label
                  ><h6>{{ $t("risk.description") }} <span class="text-danger">*</span></h6></template
                >
                <sweet-textarea v-model="form.description" :rows="3" />
              </b-form-group>
            </div>

            <div class="w-30">
              <div class="d-flex flex-row">
                <div>
                  <h6>{{ $t("risk.threat-definition.text") }} <span class="text-danger">*</span></h6>
                </div>
                <div>
                  <right-panel
                    class="float-left"
                    id="sidebar-threat-definition"
                    width="600px"
                    :icon="'mdi mdi-plus'"
                    :text="$t('risk.threat-definition.new')"
                    @hidden="rightPanelClosed"
                  >
                    <div class="pl-5 pr-5">
                      <OrganizationRiskThreatDefinitionForm @onSave="onThreatSaved" :hide-library="true" />
                    </div>
                  </right-panel>
                </div>
              </div>

              <div class="p-2">
                <filter-select
                  id="threatFilter"
                  ref="threatFilter"
                  :limit="3"
                  :placeholder="$t('risk.threat-definition.text')"
                  :multiple="true"
                  @filter="onThreatDefinitionSearch"
                  :selected="form.threats"
                  @changed="onThreatDefinitionSelect"
                />
              </div>
            </div>

            <div class="w-30">
              <div class="d-flex flex-row">
                <div>
                  <h6>{{ $t("risk.weakness-definition.text") }} <span class="text-danger">*</span></h6>
                </div>
                <div>
                  <right-panel
                    class="float-left"
                    id="sidebar-weakness-definition"
                    width="600px"
                    :icon="'mdi mdi-plus'"
                    :text="$t('risk.weakness-definition.new')"
                    @hidden="rightPanelClosed"
                  >
                    <div class="pl-5 pr-5">
                      <OrganizationRiskWeaknessDefinitionForm @onSave="onWeaknessSaved" :hide-library="true" />
                    </div>
                  </right-panel>
                </div>
              </div>
              <div class="p-2">
                <filter-select
                  id="weaknessFilter"
                  ref="weaknessFilter"
                  :limit="3"
                  :placeholder="$t('risk.weakness-definition.text')"
                  :multiple="true"
                  @filter="onWeaknessDefinitionSearch"
                  :selected="form.weaknesses"
                  @changed="onWeaknessDefinitionSelect"
                />
              </div>
            </div>

            <div class="w-30">
              <div class="d-flex flex-row">
                <div>
                  <h6>{{ $t("risk.source.text") }} <span class="text-danger">*</span></h6>
                </div>
                <div>
                  <right-panel class="float-left" id="sidebar-risk-source" width="600px" :icon="'mdi mdi-plus'" :text="$t('risk.source.new')" @hidden="rightPanelClosed">
                    <div class="pl-5 pr-5">
                      <OrganizationRiskSourceForm @onSave="onSourceSaved" :hide-library="true" />
                    </div>
                  </right-panel>
                </div>
              </div>
              <div class="p-2">
                <filter-select
                  id="sourceFilter"
                  ref="sourceFilter"
                  :limit="3"
                  :placeholder="$t('risk.source.text')"
                  :multiple="false"
                  @filter="onSourceSearch"
                  :selected="form.sources"
                  @changed="onSourceSelect"
                />
              </div>
            </div>
            <div class="w-30">
              <div class="d-flex flex-row">
                <div>
                  <h6>{{ $t("risk.category.text") }} <span class="text-danger">*</span></h6>
                </div>
                <div>
                  <right-panel class="float-left" id="sidebar-risk-category" width="600px" :icon="'mdi mdi-plus'" :text="$t('risk.category.new')" @hidden="rightPanelClosed">
                    <div class="pl-5 pr-5">
                      <OrganizationRiskCategoryForm @onSave="onCategorySaved" :hide-library="true" />
                    </div>
                  </right-panel>
                </div>
              </div>
              <div class="p-2">
                <filter-select
                  id="categoryFilter"
                  ref="categoryFilter"
                  :limit="3"
                  :placeholder="$t('risk.category.text')"
                  :multiple="false"
                  @filter="onCategorySearch"
                  :selected="form.category"
                  @changed="onCategorySelect"
                />
              </div>
            </div>

            <div class="w-30">
              <div class="d-flex flex-row">
                <div>
                  <h6>{{ $t("risk.type.text") }} <span class="text-danger">*</span></h6>
                </div>
                <div>
                  <right-panel class="float-left" id="sidebar-risk-type" width="600px" :icon="'mdi mdi-plus'" :text="$t('risk.type.new')" @hidden="rightPanelClosed">
                    <div class="pl-5 pr-5">
                      <OrganizationRiskTypeForm @onSave="onTypeSaved" :hide-library="true" />
                    </div>
                  </right-panel>
                </div>
              </div>
              <div class="p-2">
                <filter-select
                  id="typeFilter"
                  ref="typeFilter"
                  :limit="3"
                  :placeholder="$t('risk.type.text')"
                  :multiple="false"
                  @filter="onTypeSearch"
                  :selected="form.type"
                  @changed="onTypeSelect"
                />
              </div>
            </div>

            <div class="w-30">
              <div class="d-flex flex-row">
                <div>
                  <h6>{{ $t("risk.kind.text") }}</h6>
                </div>
                <div>
                  <right-panel class="float-left" id="sidebar-risk-kind" width="600px" :icon="'mdi mdi-plus'" :text="$t('risk.kind.new')" @hidden="rightPanelClosed">
                    <div class="pl-5 pr-5">
                      <OrganizationRiskKindForm @onSave="onKindSaved" :hide-library="true" />
                    </div>
                  </right-panel>
                </div>
              </div>
              <div class="p-2">
                <filter-select
                  id="kindFilter"
                  ref="kindFilter"
                  :limit="3"
                  :placeholder="$t('risk.kind.text')"
                  :multiple="false"
                  @filter="onKindSearch"
                  :selected="form.kind"
                  @changed="onKindSelect"
                />
              </div>
            </div>

            <div class="w-30 mt-1">
              <label>{{ $t("risk.level.text") }} <span class="text-danger">*</span></label>
              <select @change="ownerChanged" class="form-control" v-model="selectedOwnerType">
                <option value="ORGANIZATION">{{ $t("audit-control.control-level.corporate") }}</option>
                <option value="DEPARTMENT">{{ $t("department.text") }}</option>
                <option value="PROCESS">{{ $t("process.text") }}</option>
              </select>
            </div>

            <div class="w-30 mt-1">
              <div v-if="selectedOwnerType == 'ORGANIZATION'">
                <label>{{ $t("organization.text") }}</label>
                <filter-select
                  disabled
                  v-show="currentOrganization"
                  :selected="{ _id: currentOrganization._id, name: { tr: currentOrganization.name, en: currentOrganization.name } }"
                  :placeholder="$t('organization.text')"
                  :multiple="false"
                  :custom-label="customLabel"
                />
              </div>
              <div v-if="selectedOwnerType == 'DEPARTMENT'">
                <label>{{ $t("department.text") }}</label>
                <filter-select
                  ref="departmentFilter"
                  :selected="form.owner ? form.owner.department : null"
                  :placeholder="$t('department.text')"
                  :multiple="false"
                  @filter="onDepartmentSearch"
                  @changed="onDepartmentSelect"
                />
              </div>
              <div v-if="selectedOwnerType == 'PROCESS'">
                <label>{{ $t("process.text") }}</label>
                <filter-select
                  ref="processFilter"
                  @filter="onProcessSearch"
                  :selected="form.owner ? form.owner.process : null"
                  :placeholder="$t('process.text')"
                  :multiple="false"
                  @changed="onProcessSelect"
                />
              </div>
            </div>

            <div class="r-select-container mt-1 w-30">
              <h6>{{ $t("risk.admin") }}</h6>
              <organization-member-select :selected="form.admin" @onSelect="onMemberSelect" :organization="currentOrganization" />
              <!-- <sweet-input class="d-block" :placeholder="$t('risk.admin')" v-model="form.admin" :isValid="!$v.form.admin.$error" /> -->
            </div>

            <div class="r-select-container w-30">
              <h6>{{ $t("risk.reporting-person") }}</h6>
              <sweet-input :disableValidation="true" v-model="form.reportingPerson" type="text" :placeholder="$t('risk.reporting-person')" />
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("audit-control.control.compliance-items") }}</label>

                  <span v-b-modal="'compliance-item-modal-select'" class="text-primary">
                    <i class="bx bx-search font-size-16 align-middle"></i>
                    {{ $t("compliance-item.add") }}
                  </span>
                  <ComplianceItemSelect
                    id="compliance-item-modal-select"
                    multiple="true"
                    :title="$t('compliance-item.add')"
                    store="libraryComplianceItem"
                    @selected="complianceItemSelected"
                  />

                  <table class="table table-bordered table-striped bg-white">
                    <thead class="bg-secondary text-white">
                      <tr>
                        <td class="w-10">{{ $t("compliance-item.compliance") }}</td>
                        <td class="w-10">{{ $t("finding.form.compliance-item-group-text") }}</td>
                        <td class="w-10">{{ $t("finding.form.compliance-item-no") }}</td>
                        <td class="w-10">{{ $t("finding.form.compliance-item-level") }}</td>
                        <td class="w-60">{{ $t("finding.form.compliance-item-name") }}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in form.complianceItems" :key="item._id">
                        <td>{{ item.compliance }}</td>
                        <td>
                          <span v-if="item.group">{{ item.group.name | translate }}</span>
                        </td>
                        <td>{{ item.no }}</td>
                        <td>{{ item.level }}</td>
                        <td>{{ item.name | translate }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("risk.related-asset-groups") }}</label>

                  <span @click="$root.$emit('bv::toggle::collapse', 'sidebar-new-asset-group')" class="text-primary">
                    <i class="bx bx-search font-size-16 align-middle hand"></i>
                    {{ $t("risk.asset-groups.new") }}
                  </span>

                  <right-panel class="float-right mt-2" id="sidebar-new-asset-group" width="800px" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
                    <div class="pl-5 pr-5">
                      <RiskAssetGroupRelationForm :localMode="true" @onAdd="handleAssetGroupAdd"></RiskAssetGroupRelationForm>
                    </div>
                  </right-panel>

                  <table class="table table-bordered table-striped bg-white">
                    <thead class="bg-secondary text-white">
                      <tr>
                        <td class="w-20">{{ $t("asset-group-category.text") }}</td>
                        <td class="w-20">{{ $t("asset-group.text") }}</td>
                        <td class="w-10">{{ $t("asset-group.degree-of-criticality") }}</td>
                        <td class="w-10">{{ $t("risk.possibility") }}</td>
                        <td class="w-10">{{ $t("risk.effect") }}</td>
                        <td class="w-20">{{ $t("common.description") }}</td>
                        <td class="w-10">{{ $t("common.delete") }}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in form.riskAssetGroupRelations" :key="'ragr-' + index">
                        <td>
                          <span v-if="item.assetGroupCategory">{{ item.assetGroupCategory.name | translate }}</span>
                        </td>
                        <td>
                          <span v-if="item.assetGroup">{{ item.assetGroup.name | translate }}</span>
                        </td>
                        <td>
                          <span v-if="item.assetGroup">{{ item.assetGroup.criticalityLevel }}</span>
                        </td>
                        <td>{{ item.possibility }}</td>
                        <td>{{ item.effectValue }}</td>
                        <td>{{ item.description | translate }}</td>
                        <td>
                          <button class="btn btn-sm btn-danger" @click="removeLocalAssetGroup(index)">
                            <i class="bx bx-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="w-100">
              <h6>{{ $t("common.note") }}</h6>
              <textarea v-model="form.note" type="text" class="form-control" :placeholder="$t('common.note')" rows="3"></textarea>
            </div>

            <div class="w-100">
              <h5>{{ $t("risk.initial-risk-point") }}</h5>
            </div>
            <div class="w-25">
              <div>
                <h6>
                  {{ $t("risk.possibility") }}
                  <i id="popover-possibility" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i>
                </h6>

                <b-popover container="popover-info" custom-class="wide-popover" target="popover-possibility" triggers="hover focus" placement="right">
                  <!-- <template #title>İstatistikler</template> -->
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th>{{ $t("risk.possibility") }}</th>
                        <th>{{ $t("risk.info.possibility.title") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="level in [1, 2, 3, 4, 5]" :key="`possibility-${level}`">
                        <td>
                          <p class="mb-1">{{ level }}-{{ $t(getAppliedRiskValueKey(level)) }}</p>
                        </td>
                        <td>
                          <p v-for="(line, idx) in getPossibilityLines(level)" :key="`possibility-${level}-${idx}`" class="mb-1">{{ line }}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-popover>

                <select class="form-control" v-model="form.possibility" :disabled="hasAssetGroups">
                  <option :value="1">1-{{ $t("risk.applied-risk-value.lowest") }} </option>
                  <option :value="2">2-{{ $t("risk.applied-risk-value.low") }}</option>
                  <option :value="3">3-{{ $t("risk.applied-risk-value.medium") }}</option>
                  <option :value="4">4-{{ $t("risk.applied-risk-value.high") }}</option>
                  <option :value="5">5-{{ $t("risk.applied-risk-value.highest") }}</option>
                </select>
              </div>
            </div>
            <div class="w-25 ml-4">
              <div>
                <h6 style="display: inline-block;">
                  {{ $t("risk.effect") }}
                </h6>

                <i id="popover-effect" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i>
                <b-popover container="popover-info" custom-class="wide-popover" target="popover-effect" triggers="hover focus" placement="right">
                  <!-- <template #title>İstatistikler</template> -->
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th>{{ $t("risk.effect") }}</th>
                        <th>{{ $t("risk.info.effect.title") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="level in [1, 2, 3, 4, 5]" :key="`effect-${level}`">
                        <td>
                          <p class="mb-1">{{ level }}</p>
                        </td>
                        <td>
                          <p class="mb-1">{{ $t(`risk.info.effect.${level}`) }}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-popover>

                <select class="form-control" v-model="form.effectValue" :disabled="hasAssetGroups">
                  <option :value="1">1</option>
                  <option :value="2">2</option>
                  <option :value="3">3</option>
                  <option :value="4">4</option>
                  <option :value="5">5</option>
                </select>
              </div>
            </div>
            <div class="w-25">
              <h6 class="mt-1">
                {{ $t("risk.risk-point") }}
                <i id="popover-point" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i>
              </h6>

              <input disabled v-model="form.riskPoint" type="number" min="1" max="50" class="form-control" />
            </div>
            <b-popover container="popover-info" custom-class="wide-popover" target="popover-point" triggers="hover focus" placement="right">
              <!-- <template #title>İstatistikler</template> -->
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>{{ $t("risk.risk-point") }}</th>
                    <th>{{ $t("risk.info.point.title") }}</th>
                  </tr>
                </thead>
                <tbody v-if="riskRatingDefinition">
                  <tr>
                    <td class="bg-success">
                      <p class="mb-1">{{ $t("risk.applied-risk-value.low") }}</p>
                      <p class="mb-1">({{ riskRatingDefinition.lowest.min }}-{{ riskRatingDefinition.low.max }})</p>
                    </td>
                    <td>
                      <p class="mb-1">{{ $t(`risk.info.point.1`) }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-light-warning">
                      <p class="mb-1">{{ $t("risk.applied-risk-value.medium") }}</p>
                      <p class="mb-1">({{ riskRatingDefinition.medium.min }}-{{ riskRatingDefinition.medium.max }})</p>
                    </td>
                    <td>
                      <p class="mb-1">{{ $t(`risk.info.point.2`) }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-danger">
                      <p class="mb-1">{{ $t("risk.applied-risk-value.high") }}</p>
                      <p class="mb-1">({{ riskRatingDefinition.high.min }}-{{ riskRatingDefinition.highest.max }})</p>
                    </td>
                    <td>
                      <p class="mb-1">{{ $t(`risk.info.point.3`) }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-popover>
          </div>
        </div>
      </b-card>

      <b-card>
        <div class="w-100">
          <h5>{{ $t("audit-finding.section.approval") }}</h5>
          <b-card class="mb-3">
            <b-row>
              <b-col md="6">
                <b-form-group :label="$t('common.approver')">
                  <b-form-input :value="expectedApproverName" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group :label="$t('common.reporter-note')">
                  <sweet-textarea v-model="form.reporterNote" :rows="3" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </b-card>

      <div class="justify-content-end d-flex">
        <sweet-button @click="save()" buttonClass="ml-2" :disabled="isDisabled" :loading="isUpdating" variant="success" size="lg" icon="mdi mdi-check">
          {{ $t("common.save") }}
        </sweet-button>
        <sweet-button @click="cancel()" buttonClass="ml-2" :disabled="isDisabled" :loading="isUpdating" variant="secondary" size="lg" icon="mdi mdi-cancel">
          {{ $t("common.cancel") }}
        </sweet-button>
      </div>
    </div>
  </div>
</template>

<script>
import PropertyUtil from "@/helpers/property-util";
import SweetTextarea from "@c/form/sweet-textarea";
import ModalSelect from "@c/modal-select";
import OrganizationMemberSelect from "@cc/organization-member-select";
import ComplianceItemSelect from "../audit-control/control/compliance-item-select.vue";
import AppliedRiskValueBadge from "./component/applied-risk-value-badge";
import RiskCategoryBadge from "./component/risk-category-badge";
import OrganizationRiskAppliedControlForm from "./applied-control/organization-risk-applied-control-form.vue";
import OrganizationRiskThreatDefinitionForm from "./threat-definition/organization-risk-threat-definition-form.vue";
import OrganizationRiskWeaknessDefinitionForm from "./weakness-definition/organization-risk-weakness-definition-form.vue";
import OrganizationRiskSourceForm from "./source/organization-risk-source-form.vue";
import OrganizationRiskTypeForm from "./type/organization-risk-type-form.vue";
import OrganizationRiskKindForm from "./kind/organization-risk-kind-form.vue";
import OrganizationRiskCategoryForm from "./category/organization-risk-category-form.vue";
import RiskAppliedControlRecommendation from "./applied-control/risk-applied-control-recommendation";
import RiskAssetGroupRelationForm from "./risk-asset-group/risk-asset-group-relation-form";

import { required } from "vuelidate/lib/validators";

export default {
  components: {
    RiskCategoryBadge,
    ComplianceItemSelect,
    AppliedRiskValueBadge,
    ModalSelect,
    OrganizationMemberSelect,
    SweetTextarea,
    RiskAppliedControlRecommendation,
    OrganizationRiskAppliedControlForm,
    OrganizationRiskThreatDefinitionForm,
    OrganizationRiskWeaknessDefinitionForm,
    OrganizationRiskSourceForm,
    OrganizationRiskTypeForm,
    OrganizationRiskKindForm,
    OrganizationRiskCategoryForm,
    RiskAssetGroupRelationForm,
  },

  props: ["hideGoBack"],
  data() {
    return {
      form: {
        riskAssetGroupRelations: [],
        name: undefined,
        description: undefined,
        threats: undefined,
        weaknesses: undefined,
        source: undefined,
        type: undefined,
        kind: undefined,
        category: undefined,
        riskPoint: undefined,
        complianceItems: undefined,
        admin: undefined,
        possibility: undefined,
        effectValue: undefined,
        owner: { organiation: undefined, department: undefined, process: undefined },
      },
      selectedOwnerType: "ORGANIZATION",

      isThereUnsavedChange: false,
      reloadMessage: this.$t("common.reload-message"),
      previousName: undefined,
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters["organizationRisk/isLoading"];
    },
    isAcceptableRisk() {
      return this.form.degree === "ACCEPT";
    },

    isDisabled() {
      return this.isLoading;
    },
    hasAssetGroups() {
      return this.form.riskAssetGroupRelations && this.form.riskAssetGroupRelations.length > 0;
    },
    isUpdating() {
      return this.$store.getters["organizationRisk/isUpdating"];
    },
    isCreating() {
      return this.$store.getters["organizationRisk/isCreating"];
    },
    risk() {
      return this.$store.getters["organizationRisk/risk"];
    },

    expectedApproverName() {
      if (this.selectedOwnerType === "ORGANIZATION") {
        return this.currentOrganization ? `${this.currentOrganization.createdBy.name} ${this.currentOrganization.createdBy.surname || ""}` : "-";
      } else if (this.selectedOwnerType === "DEPARTMENT" && this.form.owner && this.form.owner.department) {
        const dept = this.form.owner.department;
        if (dept.admins && dept.admins.length > 0) {
          return `${dept.admins[0].account.name} ${dept.admins[0].account.surname || ""}`;
        }
        return "-";
      } else if (this.selectedOwnerType === "PROCESS") {
        return this.currentOrganization ? `${this.currentOrganization.createdBy.name} ${this.currentOrganization.createdBy.surname || ""}` : "-";
      }
      return "-";
    },
    isSendingApproval() {
      return this.$store.getters["organizationMember/isSendingApproval"];
    },
    riskRatingDefinition() {
      return this.$store.getters[`organizationRisk/riskRatingDefinition`];
    },
    hasRiskAdminPermission() {
      return this.currentAccountHasPermissions([]);
    },
    hasResolvePermission() {
      if (this.form?.approval?.status != "PENDING") {
        return false;
      }

      if (this.form?.approval?.assignee?._id?.toString() == this.currentAccount._id.toString()) {
        return true;
      }

      return false;
    },
  },
  watch: {
    "form.riskDecision": {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.form.riskDecision = "MINIMIZE";
        }
      },
    },
    "form.effectValue": {
      deep: true,
      handler(v, o) {
        if (!this.hasAssetGroups) this.calculate();
      },
    },
    "form.possibility": {
      deep: true,
      handler(v, o) {
        if (!this.hasAssetGroups) this.calculate();
      },
    },
  },
  async mounted() {
    await this.fetchRiskRatingDefinition();
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  },

  async beforeRouteLeave(to, from, next) {
    if (!this.isThereUnsavedChange) {
      next();
      this.$store.commit("organizationRisk/reset");
      return;
    }
    const answer = await this.confirm(this.reloadMessage);
    if (answer) {
      this.$store.commit("organizationRisk/reset");
      next();
    } else {
      next(false);
    }
  },
  methods: {
    handleAssetGroupAdd(relation) {
      if (!this.form.riskAssetGroupRelations) this.$set(this.form, "riskAssetGroupRelations", []);
      this.form.riskAssetGroupRelations.push(relation);
      this.calculate();
    },
    removeLocalAssetGroup(index) {
      if (this.form.riskAssetGroupRelations) {
        this.form.riskAssetGroupRelations.splice(index, 1);
        this.calculate();
      }
    },
    handleRelationWithRiskCreated(relation) {
      this.form.riskAssetGroupRelations.push(relation);
    },
    customLabel(value) {
      return this.$options.filters.translate(value.name);
    },
    ownerChanged(e) {
      if (e.target.value == "ORGANIZATION") {
        this.onOrganizationSelect();
      }
      setTimeout(() => {
        this.$refs?.departmentFilter?.reset();
        this.$refs?.processFilter?.reset();
      }, 500);
    },
    complianceItemSelected(selections) {
      this.form = {
        ...this.form,
        complianceItems: [...selections],
      };
    },
    getAppliedRiskValueKey(level) {
      const map = {
        1: "risk.applied-risk-value.lowest",
        2: "risk.applied-risk-value.low",
        3: "risk.applied-risk-value.medium",
        4: "risk.applied-risk-value.high",
        5: "risk.applied-risk-value.highest",
      };

      return map[level] || "risk.applied-risk-value.lowest";
    },
    getPossibilityLines(level) {
      const raw = this.$t(`risk.info.possibility.${level}`);

      if (!raw || typeof raw !== "string") {
        return [];
      }

      return raw
        .split(/\n+/)
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
    },
    getdecisionLines(level) {
      const raw = this.$t(`risk.info.decision.${level}`);

      if (!raw || typeof raw !== "string") {
        return [];
      }

      return raw
        .split(/\n+/)
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
    },

    async onThreatDefinitionSearch(value, callback) {
      const response = await this.$store.dispatch(`riskThreatDefinition/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onThreatDefinitionSelect(threats) {
      this.form = { ...this.form, threats };
    },
    async onWeaknessDefinitionSearch(value, callback) {
      const response = await this.$store.dispatch(`riskWeaknessDefinition/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onWeaknessDefinitionSelect(weaknesses) {
      this.form = { ...this.form, weaknesses };
    },
    async onSourceSearch(value, callback) {
      const response = await this.$store.dispatch(`riskSource/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onSourceSelect(sources) {
      this.form = { ...this.form, sources };
    },
    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`riskCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onCategorySelect(category) {
      this.form = { ...this.form, category };
    },
    async onTypeSearch(value, callback) {
      const response = await this.$store.dispatch(`riskType/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onTypeSelect(type) {
      this.form = { ...this.form, type };
    },
    async onKindSearch(value, callback) {
      const response = await this.$store.dispatch(`riskKind/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onKindSelect(kind) {
      this.form = { ...this.form, kind };
    },
    redirectToRelatedFiles(item) {
      const url = this.currentProduct ? `/${this.currentProduct.toLowerCase()}/file-manager` : "/organization/file-manager";
      this.$router.push({ path: url, query: { risk: item._id, riskName: item.name?.[this.currentLanguage] } });
    },
    displayRiskSource(text) {
      if (text == "INTENTIONAL_UNINTENTIONAL_COMPELLING") {
        return this.$t("risk.source.intentional-unintentional-compelling");
      } else if (text == "UNINTENTIONAL") {
        return this.$t("risk.source.unintentional");
      } else if (text == "INTENTIONAL_UNINTENTIONAL") {
        return this.$t("risk.source.intentional-unintentional");
      } else if (text == "INTENTIONAL") {
        return this.$t("risk.source.intentional");
      } else if (text == "COMPELLING") {
        return this.$t("risk.source.compelling");
      } else {
        return "";
      }
    },

    onThreatSaved() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-threat-definition");
      this.$refs?.threatFilter?.searchChanged("*");
    },
    onWeaknessSaved() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-weakness-definition");
      this.$refs?.weaknessFilter?.searchChanged("*");
    },
    onSourceSaved() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-source");
      this.$refs?.sourceFilter?.searchChanged("*");
    },
    onCategorySaved() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-category");
      this.$refs?.categoryFilter?.searchChanged("*");
    },
    onTypeSaved() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-type");
      this.$refs?.typeFilter?.searchChanged("*");
    },
    onKindSaved() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-kind");
      this.$refs?.kindFilter?.searchChanged("*");
    },

    goBack() {
      if (this.$route.query.goBackPath) {
        window.location.href = `${window.location.origin}/${this.$route.query.goBackPath}`;
      } else {
        this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/risk`);
      }
    },

    async fetchRiskRatingDefinition() {
      const data = await this.$store.dispatch(`organizationRisk/fetchRiskRatingDefinition`);
      this.$store.commit("organizationRisk/editedRatingDefinition", { ...data });
    },

    onMemberSelect(item) {
      this.form = { ...this.form, admin: item };
    },
    dataOwnerName(item) {
      let name = "";
      if (item.organization) {
        name = item.organization.name;
      } else if (item.department) {
        name = item.department.name[this.currentLanguage];
      } else if (item.process) {
        name = item.process.name[this.currentLanguage];
      }
      return name;
    },

    ownerChanded(e) {
      if (e.target.value == "ORGANIZATION") {
        this.onOrganizationSelect();
      }
      setTimeout(() => {
        this.$refs?.departmentFilter?.reset();
        this.$refs?.processFilter?.reset();
      }, 500);
    },

    stringifyPossibility(possibility) {
      return possibility == 1
        ? this.$t("risk.applied-risk-value.lowest")
        : possibility == 2
        ? this.$t("risk.applied-risk-value.low")
        : possibility == 3
        ? this.$t("risk.applied-risk-value.medium")
        : possibility == 4
        ? this.$t("risk.applied-risk-value.high")
        : this.$t("risk.applied-risk-value.highest");
    },

    async save(confirm = true, alert = true) {
      // Validate required fields
      const missing = [];
      if (!this.form.name) missing.push(this.$t("risk.name"));
      if (!this.form.description) missing.push(this.$t("risk.description"));
      if (!this.form.threats || this.form.threats.length === 0) missing.push(this.$t("risk.threat-definition.text"));
      if (!this.form.weaknesses || this.form.weaknesses.length === 0) missing.push(this.$t("risk.weakness-definition.text"));
      if (!this.form.sources || this.form.sources.length === 0) missing.push(this.$t("risk.source.text"));
      if (!this.form.category) missing.push(this.$t("risk.category.text"));
      if (!this.form.type) missing.push(this.$t("risk.type.text"));

      if (missing.length > 0) {
        this.$toast.warning(this.$t("common.validation-error"));
        return;
      }

      if (confirm) {
        const ok = await this.$root.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
      }

      try {
        if (this.form.approval && this.form.approval.reporterNote) {
          this.form.approval.reporterNote = { [this.currentLanguage || tr]: this.form.approval.reporterNote };
        }
        if (this.form.effectValue && this.form.possibility) {
          await this.calculate();
        }
        if (!this.form.owner?.organization && !this.form.owner?.department && !this.form.owner?.process) {
          this.form.owner = {
            organization: this.currentOrganization,
          };
        }

        const { data } = await this.$store.dispatch("organizationRisk/save", this.form);

        this.isThereUnsavedChange = false;
        if (alert) {
          this.$toast.success(this.$t("common.success"));
        }

        this.$root.$emit("bv::toggle::collapse", "sidebar-add-new-risk");

        this.$emit("onSave", data);
        this.$emit("save", data);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async cancel() {
      this.$router.push(`/${this.currentProduct.toLowerCase()}/risk`);
    },

    async deleteById() {
      const id = this.$route.params.id;
      if (!id) {
        return;
      }

      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationRisk/delete`, id);
        this.$toast.success(this.$t("common.delete-successful"));
        this.$router.push(`/${this.currentProduct.toLowerCase()}/risk`);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async sendApproval() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        if (!this.approvalAssignee?._id) {
          this.$toast.warning(this.$t("risk.approval-assignee-required"));
        }
        await this.$store.dispatch(`organizationRisk/sendApproval`, {
          id: this.risk._id,
          assignee: this.approvalAssignee,
          note: {
            [this.currentLanguage]: this.approvalNote,
          },
        });
        this.$toast.success(this.$t("common.successful"));

        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async resolveApproval() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationRisk/resolveApproval`, {
          id: this.risk._id,
          status: this.approvalStatus,
          note: {
            [this.currentLanguage]: this.approvalNote,
          },
        });
        this.$toast.success(this.$t("common.successful"));
        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    riskDecisionText(value) {
      let text;
      if (value == "ACCEPT") {
        text = this.$t("risk.applied-risk-decision.accept");
      } else if (value == "AVOID") {
        text = this.$t("risk.applied-risk-decision.avoid");
      } else if (value == "TRANSFER") {
        text = this.$t("risk.applied-risk-decision.transfer");
      } else if (value == "MINIMIZE") {
        text = this.$t("risk.applied-risk-decision.minimize");
      }
      return text;
    },

    openTaskDetailModal(task) {
      this.$store.dispatch("task/fetchDetail", task._id);
      this.$store.commit("task/showTaskDetailModal", true);
    },

    async removeTaskRiskRelation(task) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("task/removeTaskRiskRelation", {
          taskId: task._id,
          riskId: this.risk._id,
        });
        this.$toast.success(this.$t("common.successful"));
        await this.save(false);
        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async linkWithTask(confirm = true) {
      if (confirm) {
        const ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
      }

      try {
        await this.$store.dispatch("task/addTaskRiskRelation", {
          taskId: this.selectedTask._id,
          riskId: this.risk._id,
        });
        await this.save(false);
        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    openPolicyDetailModal(policy) {
      this.$store.commit("organizationPolicy/policyId", policy._id);
      this.fetchDetail();
    },
    editPolicy(id) {
      this.$store.commit("organizationPolicy/isEditing", true);
      this.$store.commit("organizationPolicy/policyId", id);
    },

    async deletePolicyById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationPolicy/delete`, id);
        await this.save(false);
        this.fetchDetail();
        this.$toast.success(this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    //Calculations..-->

    async calculate() {
      try {
        if (this.hasAssetGroups) {
          let selectedRelation = null;
          let maxCriticality = -1;

          for (const relation of this.form.riskAssetGroupRelations) {
            const criticality = relation.assetGroup?.criticalityLevel || 1;
            if (criticality > maxCriticality) {
              maxCriticality = criticality;
              selectedRelation = relation;
            } else if (criticality === maxCriticality) {
              const currentScore = (selectedRelation.possibility || 1) * (selectedRelation.effectValue || 1) * maxCriticality;
              const newScore = (relation.possibility || 1) * (relation.effectValue || 1) * criticality;
              if (newScore > currentScore) {
                selectedRelation = relation;
              }
            }
          }

          if (selectedRelation) {
            this.form.possibility = selectedRelation.possibility;
            this.form.effectValue = selectedRelation.effectValue;
            this.form.riskPoint = (selectedRelation.possibility || 1) * (selectedRelation.effectValue || 1) * maxCriticality;
          }
        } else if (this.form.possibility && this.form.effectValue) {
          this.form.riskPoint = this.form.possibility * this.form.effectValue;
        }
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    // selections...-->

    async onTaskSearch(value, callback) {
      const response = await this.$store.dispatch(`task/fetchOrganizationTasks`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },

    onTaskSelect(task) {
      this.selectedTask = task;
    },

    async onPolicySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationPolicy/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, products: { value: this.currentProduct || "PLATFORM", isObject: true } },
      });

      callback(response.data?.docs ?? []);
    },

    onPolicySelect(policy) {
      this.selectedPolicy = policy;
    },

    onLegalAdminSelect(item) {
      this.approvalAssignee = {
        name: item.name,
        _id: item.accountId,
      };
    },
    async riskDefinitionSelected(item) {
      try {
        const lang = this.currentLanguage;
        this.form = {
          ...this.form,
          name: item.name[lang],
          threats: item.threats,
          weaknesses: item.weaknesses,
        };

        const data = await this.fetchRiskDetailByDefinition(item.name[this.currentLanguage]);

        if (data) {
          this.handleExistingRisk(data);
        }
      } catch (error) {}
    },
    async handleExistingRisk(data) {
      // const answer = await this.confirm("Aynı Risk tanımına sahip bir risk organizasyonda mevcut. Var olan risk ile form doldurulsun mu? ");
      // if (answer) {
      this.$store.commit("organizationRisk/risk", data);
      this.$store.commit("organizationRisk/editedEntity", data);

      if (!data.products.some((p) => p === this.currentProduct)) {
        data.products.push(this.currentProduct);
        this.form = {
          ...this.prepareFormForEdit(data, ["note", "riskPointGoal", "budgetPlan", "preventionPlanNote", "currentControls"]),
        };
        // await this.save(false);
      }
      // } else {
      //   this.form = {};
      //   this.$store.commit("organizationRisk/reset");
      // }
    },
    threatDefinitionSelected(items) {
      const lang = this.currentLanguage;

      this.form = {
        ...this.form,
        threatDefinition: items.map((i) => i.name[lang]).join(",\r"),
      };
    },
    appliedControlSelected(items) {
      const lang = this.currentLanguage;

      this.form = {
        ...this.form,
        appliedControl: items.map((i) => i.name[lang]).join(",\r"),
      };
    },

    onOrganizationSelect() {
      const dataOwner = { ...dataOwner, organization: this.currentOrganization };
      this.form = { ...this.form, dataOwner };
    },

    async onDepartmentSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartment/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onDepartmentSelect(department) {
      const dataOwner = { ...dataOwner, department };
      this.form = { ...this.form, dataOwner };
    },

    async onProcessSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationProcess/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onProcessSelect(process) {
      const dataOwner = { ...dataOwner, process };
      this.form = { ...this.form, dataOwner };
    },

    onThirdPartySelect(thirdParty) {
      this.form = { ...this.form, thirdParty };
      // this.$refs.thirdPartyFilter?.reset();
    },
    taskCreated(task) {
      this.selectedTask = task;

      this.linkWithTask(false);
      this.$refs.taskFilter.reset();
      // this.fetchDetail();
    },

    async onAppliedControlSearch(value, callback) {
      const response = await this.$store.dispatch(`riskAppliedControl/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...this.appliedControlproductQuery },
      });
      callback(response.data?.docs ?? []);
    },
    onAppliedControlSelect(items) {
      this.form = { ...this.form, appliedControl: items };
    },

    async removeRiskAssetGroupRelation(id) {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationRiskAssetGroupRelation/delete`, id);
        await this.paginateRiskAssetGroupRelation();
        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async rightPanelClosed() {},
    //History
    buildHistory() {
      const loopObject = [...this.risk.history];
      //
      if (this.risk && this.risk.history.length > 1) {
        const latest = { ...this.risk, latest: true };

        latest.name = { [this.currentLanguage]: latest.name[this.currentLanguage] };

        if (!latest.dataOwner?.organization) {
          delete latest.dataOwner?.organization;
        }
        if (!latest.dataOwner?.department) {
          delete latest.dataOwner?.department;
        }
        if (!latest.dataOwner?.process) {
          delete latest.dataOwner?.process;
        }

        if (latest.updatedBy) {
          latest.updatedBy = {
            _id: latest.updatedBy._id,
            name: latest.updatedBy.name,
            ref: { _id: latest.updatedBy._id },
          };
        }
        if (latest.approval) {
          latest.approval = {
            ...latest.approval,
            reporter: {
              _id: latest.approval.reporter._id,
              name: latest.approval.reporter.name,
              ref: { _id: latest.approval.reporter._id },
            },
            assignee: {
              _id: latest.approval.assignee._id,
              name: latest.approval.assignee.name,
              ref: { _id: latest.approval.assignee._id },
            },
          };
        }
        if (latest.riskPointGoal) {
          latest.riskPointGoal = { [this.currentLanguage]: latest.riskPointGoal[this.currentLanguage] };
        }
        if (latest.appliedControl) {
          latest.appliedControl = latest.appliedControl.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }
        if (latest.threats) {
          latest.threats = latest.threats.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }
        if (latest.weaknesses) {
          latest.weaknesses = latest.weaknesses.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }
        if (latest.dataOwner) {
          latest.dataOwner = {
            _id: latest.dataOwner._id,
            name: latest.dataOwner.name,
          };
        }

        // loopObject.unshift(latest);
      }
      //
      this.historyItems = [];
      let prev = null;
      const arr = loopObject.reverse();

      for (const r of arr) {
        const risk = { ...r };

        risk.name = { [this.currentLanguage]: risk.name[this.currentLanguage] };

        if (!risk.dataOwner?.organization) {
          delete risk.dataOwner?.organization;
        }
        if (!risk.dataOwner?.department) {
          delete risk.dataOwner?.department;
        }
        if (!risk.dataOwner?.process) {
          delete risk.dataOwner?.process;
        }

        if (risk.riskPointGoal) {
          risk.riskPointGoal = { [this.currentLanguage]: risk.riskPointGoal[this.currentLanguage] };
        }

        if (risk.appliedControl) {
          risk.appliedControl = risk.appliedControl.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }
        if (risk.threats) {
          risk.threats = risk.threats.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }
        if (risk.weaknesses) {
          risk.weaknesses = risk.weaknesses.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }

        if (risk.note) {
          risk.note = {
            [this.currentLanguage]: risk.note[this.currentLanguage],
          };
        }
        if (risk.preventionPlanNote) {
          risk.preventionPlanNote = {
            [this.currentLanguage]: risk.preventionPlanNote[this.currentLanguage],
          };
        }

        //<--

        if (!prev) {
          prev = { ...risk, changes: [] };
          this.historyItems.push(prev);
          continue;
        }
        const diffs = PropertyUtil.getPropsDiff(prev, risk);

        delete diffs.at;

        this.historyItems = [
          {
            ...risk,
            changes: Object.keys(diffs),
          },
          ...this.historyItems,
        ];

        prev = risk;
      }
    },
    //
    beforeUnload(e) {
      if (!this.isThereUnsavedChange) {
        return undefined;
      }

      (e || window.event).returnValue = this.reloadMessage;
      return this.reloadMessage;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./organization-risk-view.scss";
</style>

<style scoped>
table {
  table-layout: fixed;
  word-wrap: break-word;
}

.diff {
  background: #ffe0e0;
}

.card-body .card-header {
  background-color: #ebedf9 !important;
}

.card-header[role="tab"],
.card-header .accordion-list {
  background-color: #e2e0ff !important;
}

.card-header[role="tab"].bg-success,
.card-header.bg-success .accordion-list {
  background-color: #eaf5ff !important;
}
.card-header[role="tab"].bg-primary,
.card-header.bg-success .accordion-list {
  background-color: #aedbf6 !important;
}
.card-header[role="tab"].bg-danger,
.card-header.bg-success .accordion-list {
  background-color: #f9dfd4 !important;
}
.custom-radius {
  border-radius: 0.625rem;
}
.custom-card {
  border-radius: 0.625rem;
  padding: 0.5rem;

  margin-bottom: 1.5rem;
}
.legend {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.box {
  width: 20px;
  height: 20px;
}
.bg-light-warning {
  background-color: #ffbd8a;
}
</style>

<style>
.popover.wide-popover {
  max-width: 800px !important;
  width: auto !important;
}

.popover.wide-popover .popover-body {
  max-width: auto !important;
}

.popover.wide-popover .popover-body table {
  table-layout: auto !important;
}

.popover.wide-popover .popover-body td:first-child {
  width: 140px;
  white-space: nowrap;
  vertical-align: top;
}
</style>
